var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('HeroSection',{attrs:{"id":"hero"}}),_c('InfoSection',{attrs:{"id":"about"}}),_c('RouteSection',{attrs:{"id":"route"}}),_c('GallerySection',{attrs:{"id":"gallery","year":2025}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }